import { render, staticRenderFns } from "./NewConversationNotification.modal.vue?vue&type=template&id=0f1c3061&scoped=true&"
import script from "./NewConversationNotification.modal.vue?vue&type=script&lang=js&"
export * from "./NewConversationNotification.modal.vue?vue&type=script&lang=js&"
import style0 from "./NewConversationNotification.modal.vue?vue&type=style&index=0&id=0f1c3061&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c3061",
  null
  
)

export default component.exports